enum flowSteps {
  LOGIN_REQUIRED = "LOGIN_REQUIRED",
  T_AND_C_REQUIRED = "T_AND_C_REQUIRED",
}

export default flowSteps;
